// extracted by mini-css-extract-plugin
module.exports = {"formRow":"ShippingAddressCheckout_formRow__1jqI1","selectDropdown":"ShippingAddressCheckout_selectDropdown__3QKDp","postalCode":"ShippingAddressCheckout_postalCode__3PYE_"};